<template>
    <div>
        <b-container class="pt-2">
            <p class="h1 mb-0 text-center" v-show="iconoVisible">
                <b-icon
                    :icon="elIcono"
                    class="rounded-circle border border-dark p-2"
                    variant="dark"
                ></b-icon>
            </p>
            <h3>{{ titulo }}</h3>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'Nombre',
    props: {
        titulo: String,
        icono: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            iconoVisible: false,
            elIcono: ''
        }
    },
    created() {
        if (this.icono != '') {
            if (this.icono == 'contacto') { this.elIcono = 'telephone' }
            if (this.icono == 'documento') { this.elIcono = 'FileText' }
            if (this.icono == 'tierra') { this.elIcono = 'globe' }
            this.iconoVisible = true
        } else {

        }
    },
}
</script>

<style scoped>
h3 {
    text-align: center;
}
</style>